<template>
  <div id="InquiryList" class="wrap">
    <div class="formWrap">
      <h1 class="title">問合せ - 一覧</h1>

      <div class="recordWrap">
        <!-- 絞り込み条件 -->
        <div id="searchWrap">
          <div class="bold">絞り込み条件</div>
          <div class="search_area flex flex-wrap">
            <div class="searchShort inlineBlock searchSpace">
              <div>ステータス</div>
              <div>
                <b-form-select
                  v-model="fStatus"
                  :options="statusOptions">
                  <template v-slot:first>
                    <option :value="null">-- すべて --</option>
                  </template>
                </b-form-select>
              </div>
            </div>
          </div>
        </div>

        <!-- 新規問合せ -->
        <div class="flex mb-2">
          <b-button
            variant="primary"
            class="btn btn-primary bold ml-auto"
            @click="goForm">問合せ</b-button>
        </div>

        <div class="flex flex-between my-2">
          <b-pagination
            class="mb-1"
            :value="currentPage"
            @input="setCurrentPage($event)"
            :total-rows="totalRows"
            :per-page="perPage"/>
          <div>
            <div class="inlineBlock mr-2">
              {{ nowPageCount }}件 / 全{{ totalRows }}件
            </div>
            <div class="inlineBlock mr-2">
              <span class="mr-2">表示件数</span>
              <b-form-select
                class="per-page-select"
                :value="perPage"
                @change="setPerPage"
                :options="pageOptions"/>
            </div>
          </div>
        </div>
        <b-table
          show-empty
          :fields="heads"
          :items="filteredList"
          id="inquiryList"
          thead-tr-class="head"
          tbody-tr-class="line"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @row-clicked="goDetail">
          <template v-slot:cell(status)="data">
            {{ statusTexts[data.item.status] }}
          </template>
          <template v-slot:cell(detail)="row">
            <b-link @click.stop="goDetail(row.item)">詳細</b-link>
          </template>
          <template v-slot:empty>
            <p class="none-data">問合せはありません。</p>
          </template>
        </b-table>
      </div>
    </div>

    <div class="btnWrap">
      <b-button
        class="btn back bold"
        @click="$router.push({ name: routeNames.top })">トップに戻る</b-button>
    </div>
  </div>
</template>

<script>
import api from '@/modules/api';
import moment from 'moment';
import INQUIRY from '@/constants/inquiryStatus';
import inquiryContext from '@/mixin/inquiryContext';

export default {
  name: 'gasInquiryList',
  mixins: [inquiryContext],
  data() {
    return {
      pageOptions: [10, 20, 50],
      statusTexts: INQUIRY.GAS_INQUIRY_STATUS_TEXTS,
      statusOptions: Object.keys(INQUIRY.GAS_INQUIRY_STATUS_TEXTS).map(value => ({
        value: Number(value),
        text: INQUIRY.GAS_INQUIRY_STATUS_TEXTS[value],
      })),
      heads: [
        { key: 'title', label: 'タイトル', sortable: true, class: 'title-col' },
        { key: 'updated_at', label: '最終更新日時', sortable: true, class: 'updated' },
        { key: 'status', label: 'ステータス', sortable: true, class: 'status' },
        { key: 'detail', label: '', sortable: false, class: 'detail' },
      ],
      list: [],
    };
  },
  async created() {
    await this.fetchList();
  },
  computed: {
    // --- 検索・ページング・ソートは gasInquirySearch ストアで保持（詳細から戻っても消えない） ---
    fStatus: {
      get() { return this.$store.state.gasInquirySearch.filter.status; },
      set(v) { this.$store.commit('gasInquirySearch/setFilter', { key: 'status', value: v }); },
    },
    sortBy: {
      get() { return this.$store.state.gasInquirySearch.sortBy; },
      set(v) { this.$store.commit('gasInquirySearch/setSortBy', v); },
    },
    sortDesc: {
      get() { return this.$store.state.gasInquirySearch.sortDesc; },
      set(v) { this.$store.commit('gasInquirySearch/setSortDesc', v); },
    },
    perPage() { return this.$store.state.gasInquirySearch.perPage; },
    currentPage() { return this.$store.state.gasInquirySearch.currentPage; },
    filteredList() {
      if (this.fStatus === null) {
        return this.list;
      }
      return this.list.filter(row => row.status === this.fStatus);
    },
    totalRows() {
      return this.filteredList.length;
    },
    nowPageCount() {
      if (this.totalRows === 0) {
        return 0;
      }
      let maxPage = Math.floor(this.totalRows / this.perPage);
      const mod = this.totalRows % this.perPage;
      let lastPageItemNum;
      if (mod !== 0) {
        maxPage += 1;
        lastPageItemNum = mod;
      } else {
        lastPageItemNum = this.perPage;
      }
      if (this.currentPage < maxPage) {
        return this.perPage;
      }
      return lastPageItemNum;
    },
  },
  methods: {
    async fetchList() {
      try {
        const res = await api.send(`${this.inquiryApiBase}/list`);
        const list = (res.data && res.data.list) || [];
        this.list = list.map(row => ({
          id: row.id,
          title: row.title,
          status: row.status,
          updated_at: this.formatDate(row.updated_at),
        }));
      } catch (e) {
        this.list = [];
      }
    },
    formatDate(dt) {
      return dt ? moment(dt).format('YYYY/MM/DD HH:mm') : '';
    },
    setCurrentPage(page) {
      this.$store.commit('gasInquirySearch/setCurrentPage', page);
    },
    setPerPage(num) {
      this.$store.commit('gasInquirySearch/setPerPage', num);
    },
    goForm() {
      this.$router.push({ name: this.routeNames.form });
    },
    goDetail(item) {
      this.$router.push({ name: this.routeNames.detail, query: { id: item.id } });
    },
  },
};
</script>

<style scoped>
  .title {
    color: #333333;
    font-weight: 300;
    font-size: 24px;
    margin: 52px 100px 0;
    border-bottom: solid 2px #A0A9D0;
    padding-left: 10px;
    padding-bottom: 7px;
  }
  .recordWrap {
    margin: 40px 100px 0;
  }
  #searchWrap input, #searchWrap select {
    height: 50px;
  }
  .search_area {
    background: #DDD;
    padding: 10px;
    margin-bottom: 30px;
  }
  .searchShort {
    width: 135px;
  }
  .searchSpace {
    margin-right: 15px;
    margin-bottom: 5px;
  }
  .none-data {
    margin-bottom: 1px;
    text-align: center;
  }
  .btnWrap {
    margin: 45px 0;
    text-align: center;
  }
</style>
<style>
  #inquiryList thead .head {
    background-color: #6E6E6E;
    color: #FFFFFF;
    font-weight: 600;
    font-size: 16px;
  }
  #inquiryList thead .head th {
    border: solid 1px #CCCCCC;
    word-break: keep-all;
  }
  #inquiryList tbody tr.line {
    border-bottom: solid 1px #CCCCCC;
    cursor: pointer;
  }
  #inquiryList tbody tr td {
    vertical-align: middle !important;
  }
  #inquiryList td.updated { width: 200px; }
  #inquiryList td.status { width: 140px; }
  #inquiryList td.detail { width: 80px; text-align: center; }
</style>
